import { Link, useLocation } from 'react-router-dom';
import PageBasicTemplate from '../components/PageBasicTemplate';
import { useCms, CmsStatus, HtmlContent } from '../components/redesign/Cms';
import Arrow from '../components/redesign/Arrow';
type Policy = { title: string; html_content: string };
const titles: Record<string, string> = { 'security-policy': '情報セキュリティ方針', 'privacy-policy': 'プライバシーポリシー', 'protection-policy': '個人情報保護方針' };
export default function SharedPage() {
  const location = useLocation();
  const name = location.pathname.split('/').pop() || '';
  const { data, loading, error, retry } = useCms<Policy>(`/${name}`);
  return <PageBasicTemplate title={data?.title || titles[name] || '方針・規約'} sub_title="株式会社FRiCTONの情報の取り扱いに関する方針です。">
    {loading || error || !data?.html_content ? <CmsStatus loading={loading} error={error} retry={retry} empty="現在、方針の本文を表示できません。内容の確認をご希望の方は、お問い合わせください。" /> : <HtmlContent html={data.html_content} />}
    <Link className="text-link" to="/contact" style={{ marginTop: 35 }}>お問い合わせ <Arrow /></Link>
  </PageBasicTemplate>;
}
